import React from 'react';
import useSiteContent, { imageUrl } from '../Content/useSiteContent';
import ContentNotice from '../Content/ContentNotice';

const Home = () => {
  const { data, unavailable } = useSiteContent('home');
  const background = imageUrl(data.backgroundImage);
  return (
    <div className="home-container" style={{ backgroundImage: background ? 'url("' + background.replace(/"/g, '%22') + '")' : 'none' }}>
      <ContentNotice unavailable={unavailable} />
      <div className="home-top-container">
        <img className="home-top-image" src={imageUrl(data.heroImage)} alt={data.heroAlt} />
        <h1 className="home-top-text">{data.heading}</h1>
      </div>
      {data.announcementEnabled && <section className="events-box">
        <h2>{data.announcementTitle}</h2>
        <p className="editable-text">{data.announcementText}</p>
      </section>}
      {data.sections.map((section, index) => <div className="home-image-info-container" key={index}>
        <img className="home-image-half" src={imageUrl(section.image)} alt={section.alt} />
        <div className="home-info-half-container">
          <p className="home-info-half editable-text">{section.text}</p>
        </div>
      </div>)}
    </div>
  );
};
export default Home;
